export default __webpack_public_path__ + "static/media/OKE300.68cce8ba.jpg";